import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { useEffect, useState } from "react";

import Landing from "./pages/Landing";
import PostDetail from "./pages/PostDetail";
import Subscribe from "./pages/Subscribe";
import HireElizabeth from "./pages/HireElizabeth";
import ReferralHub from "./pages/ReferralHub";
import Join from "./pages/Join";
import Newsletter from "./pages/Newsletter";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminEditor from "./pages/AdminEditor";
import AdminPosts from "./pages/AdminPosts";
import AdminSubscribers from "./pages/AdminSubscribers";
import AdminInquiries from "./pages/AdminInquiries";
import AdminLeads from "./pages/AdminLeads";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-brand-bg">
      <div className="w-8 h-8 border-2 border-brand-accent border-t-transparent rounded-full animate-spin" />
    </div>
  );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function ThemeWrapper({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("fb_theme") || "light");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("fb_theme", theme);
  }, [theme]);

  // Expose setter globally for Navbar
  useEffect(() => {
    window.__setTheme = setTheme;
    window.__getTheme = () => theme;
  }, [theme]);

  return children;
}

function App() {
  return (
    <AuthProvider>
      <ThemeWrapper>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/post/:slug" element={<PostDetail />} />
            <Route path="/subscribe" element={<Subscribe />} />
            <Route path="/hire" element={<HireElizabeth />} />
            <Route path="/referrals" element={<ReferralHub />} />
            <Route path="/join" element={<Join />} />
            <Route path="/newsletter" element={<Newsletter />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/posts" element={<ProtectedRoute><AdminPosts /></ProtectedRoute>} />
            <Route path="/admin/editor" element={<ProtectedRoute><AdminEditor /></ProtectedRoute>} />
            <Route path="/admin/editor/:id" element={<ProtectedRoute><AdminEditor /></ProtectedRoute>} />
            <Route path="/admin/subscribers" element={<ProtectedRoute><AdminSubscribers /></ProtectedRoute>} />
            <Route path="/admin/inquiries" element={<ProtectedRoute><AdminInquiries /></ProtectedRoute>} />
            <Route path="/admin/leads" element={<ProtectedRoute><AdminLeads /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ThemeWrapper>
    </AuthProvider>
  );
}

export default App;
